"use strict";
var CoverageContainerViewModel = (function () {
    function CoverageContainerViewModel() {
    }
    return CoverageContainerViewModel;
}());
exports.CoverageContainerViewModel = CoverageContainerViewModel;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/view-models/coverages/coverage-container-view.model.js